import defineService from './defineService'
const productRecommendations = defineService('get', 'api/v1/vendor/productrecommendation/', {
  suffixFunc({category}) {
    return category ? '-'+category : '';
  }
})

let cache = {};

/**
 * Return list of all products. Use a local cache, because the
 * API call is very slow.
 */
export async function products(category=null) {
  // Note: we do not handle or anticipate multiple pages for results
  let cached = cache[category];
  if (cached) return cached;
  let {results} = await productRecommendations({category});
  cache[category] = results
  return results;
}



// WEBPACK FOOTER //
// ./src/services/products.js